<template>
  <main id="order" v-if="document && completed">
    <div class="container fade-in-up" ref="container">
      <div v-for="(slice, index) of slices" :key="`${className}-${index}`">
        <router-link :to="{name: 'index'}" v-if="index === 0">
          <component :is="sliceToComponent(slice)" :slice="slice" />
        </router-link>

        <component :is="sliceToComponent(slice)" :slice="slice" :key="`${className}-${index}`" v-else />
      </div>

      <div class="time">
        Vald tid för upphämtning: {{ getTime(completed.timeslot).time }}
      </div>

      <Order />
    </div>
  </main>
</template>

<script>
  import SliceLoader from 'mixins/slice-loader';
  import TextSlice from 'components/slices/text';
  import ImageSlice from 'components/slices/image';
  import MenuSlice from 'components/slices/menu';
  import Order from 'components/order/order';
  import { getTime } from '@/lib/timeslots';
  import { mapState } from 'vuex';

  export default {
    name: 'Page',
    components: { TextSlice, ImageSlice, MenuSlice, Order },
    mixins: [SliceLoader],

    data () {
      return {
        document: null,
        contentParams: { type: 'page', uid: 'order-complete' },
        orderStarted: false
      };
    },

    computed: {
      ...mapState('order', ['completed'])
    },

    mounted () {
      if (!this.completed) {
        this.$router.push({ name: 'index' });
      } else {
        this.$refs.container.classList.add('is-active');
      }
    },

    methods: {
      sliceFor (type) {
        return this.slices.find(s => s.sliceType === type);
      },
      getTime
    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/helpers'

  main
    padding: 2rem
    min-height: 91.1vh

  .container
    animation-duration: .6s
    display: flex
    flex-direction: column
    align-items: center
    margin: 3rem 0

  .order
    width: 100%
    max-width: 600px

  .time
    margin-bottom: 4rem

</style>
